import React from 'react';
import Helper from '../../helper';

const DepositeBonusBanner = () => {
  const userInfo = Helper();
  return (
    <div className={`w-screen relative left-1/2 right-1/2 -mx-[50vw] overflow-hidden ${userInfo ? 'block hidden': 'block'}`}>
      <div className="w-full rounded-lg overflow-hidden"> {/* Adjust rounded size as needed */}
        <img
          src="https://images.staticcontent.io/rde/login/pg-banner.webp"
          alt="Full width banner"
          className="w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default DepositeBonusBanner;